export default __webpack_public_path__ + "static/collage-ro-6f328777afa0284d5a8d10f50555d28c.png";